import { LoginLogo } from '../components/LoginLogo';
import { LoginForm } from '../features/Login';
import { FullScreenBackground, RightSpacer } from '../styles/LoginContainerStyle';

export function Login() {
  return (
    <FullScreenBackground>
      {/* left space */}
      <LoginLogo />

      {/* right space */}
      <RightSpacer>
        <img src="/images/icon_basic.png" alt="ProPlus" style={{ height: 40 }} />
        <LoginForm />
      </RightSpacer>
    </FullScreenBackground>
  );
}
